import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';

import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';

import { useResumeCampaignSubscriber } from '../../hooks/useResumeCampaignSubscriber';

interface ResumeSubscriberModalProps {
  campaignId: string;
  subscriberId: string;
  onClose: () => void;
  onSuccess?: () => void;
}

export const ResumeSubscriberModal = ({
  campaignId,
  subscriberId,
  onClose,
  onSuccess,
}: ResumeSubscriberModalProps) => {
  const { t } = useTranslation();
  const { resumeSubscriberAsync, resumeSubscriberStatus } = useResumeCampaignSubscriber();
  const isResuming = resumeSubscriberStatus === 'pending';

  const handleResume = async () => {
    try {
      await resumeSubscriberAsync({ campaignId, subscriberId });
      toast.success(t('campaigns.subscriber_resumed'));
      onClose();
      onSuccess?.();
    } catch {
      // Error toast handled by the mutation onError
    }
  };

  return (
    <Dialog open onOpenChange={onClose}>
      <DialogContent className="gap-6 sm:max-w-md">
        <DialogHeader>
          <DialogTitle>{t('campaigns.resume_subscriber_title')}</DialogTitle>
          <DialogDescription>{t('campaigns.resume_subscriber_description')}</DialogDescription>
        </DialogHeader>

        <div className="flex justify-end gap-2">
          <Button variant="ghost-neutral" onClick={onClose}>
            {t('common.cancel')}
          </Button>
          <Button onClick={handleResume} isLoading={isResuming}>
            {t('campaigns.resume')}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
